import {Routes} from '@angular/router';
import {DocumentRepositoryComponent} from './component/document-repository/document-repository.component';
import {SharedDrivesComponent} from './component/shared-drives/shared-drives.component';
import {SharedWithMeComponent} from './component/shared-with-me/shared-with-me.component';
import {OrbitaxDriveComponent} from './component/drive/orbitax-drive.component';
import {OrbitaxDrivesComponent} from './component/shared-drives/orbitax-drives.component';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {PlatformToolContainerComponent} from '@shared/components/platform-tool/platform-tool-container/platform-tool-container.component';
import {FillablePdfTranslationCommandComponent} from '@features/file-manager/component/fillable-pdf-translation-command/fillable-pdf-translation-command.component';

export const fileManagerRoutes: Routes = [
  {
    path: 'repository',
    component: DocumentRepositoryComponent
  },
  {
    path: 'team-drives',
    component: SharedDrivesComponent
  },
  {
    path: 'orbitax-drives',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'orbitax-drive/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  {
    path: 'orbitax-drive/:driveId/:magicLinkId',
    component: PlatformToolContainerComponent
  },
  // {
  //   path     : 'drive/:id/:folderId',
  //   component: DriveComponent
  // },
  // {
  //   path     : 'drive/:id',
  //   component: DriveComponent
  // },
  {
    path: 'drive',
    children: [
      // {
      //   path: 'shared-with-me',
      //   component: PlatformLinkCreatorComponent
      // },
      // {
      //   path: 'notebooks',
      //   component: PlatformLinkCreatorComponent
      // },
      // {
      //   path: 'notebooks',
      //   component: PlatformLinkCreatorComponent
      // },
      // {
      //   path: 'snippets',
      //   component: PlatformLinkCreatorComponent
      // },
      // {
      //   path: 'recent',
      //   component: PlatformLinkCreatorComponent
      // },
      // {
      //   path: 'starred',
      //   component: PlatformLinkCreatorComponent
      // },
      // {
      //   path: 'trash',
      //   component: PlatformLinkCreatorComponent
      // },
      {
        path: 'eat/:magicLinkId',
        component: PlatformToolContainerComponent
      },
      {
        path: ':magicLinkId',
        component: PlatformToolContainerComponent
      },
      {
        path: '',
        component: PlatformLinkCreatorComponent
      }]
  },
  {
    path: 'shared-with-me',
    component: SharedWithMeComponent
  },
  {
    path: 'publications',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'fillablepdftranslation/:viewMode/:driveId/:itemId/:isClientDrive/:translatedFileContentId',
    component: FillablePdfTranslationCommandComponent
  }
];
